<div class="row field" *ngIf="date">
    <label class="field-label" for="{{idUnique}}"
           translate="serviceAppointmentLongLabel"></label>
    <span class="field-data qa-service-appt-date" id="{{idUnique}}"
          [ngClass]="{appointment: alertExists}">{{serviceAppointment}}</span>
</div>
